<template>
  <div class="common-footer">
    <p>Copyright <font class="fontfam">©</font><span class="mYear"> 2005 - {{ currentYear }}</span> &nbsp;<a href="//www.jianshe99.com/" target="_blank">www.jianshe99.com</a> All Rights Reserved.　北京正保建工教育科技有限公司 版权所有</p>
    <p><a rel="external nofollow" target="_blank" href="/licence/icp.htm">京B2-20200995号</a>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <a href="//beian.miit.gov.cn" target="_blank" rel="nofollow">京ICP备20013319号-1</a>&nbsp;&nbsp;&nbsp;&nbsp;
      <!--<a href="//www.jianshe99.com/licence/www.htm" target="_blank" rel="nofollow">网络文化经营许可证</a>&nbsp;&nbsp;&nbsp;&nbsp;--><a rel="external nofollow" target="_blank" href="/licence/cbw.htm">出版物经营许可证</a>&nbsp;&nbsp;&nbsp;<a target="_blank" href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802023460"><img src="//www.jianshe99.com/images/ba-icon.png" style="display:inline-block; vertical-align: middle; width: 20px; height: 20px;" border="0" width="20" height="20">京公网安备 11010802023460号</a>&nbsp;&nbsp;&nbsp;建议邮箱：<a href="mailto:jianshejy@cdeledu.com">jianshejy@cdeledu.com </a> 客服邮箱： <a href="mailto:jianshe99@cdeledu.com">
        jianshe99@cdeledu.com</a>　
    </p>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        currentYear: null
      }
    },
    mounted() {
      this.currentYear = new Date().getFullYear()
    }
  }
</script>

